export interface IBaseConfig {
  smsctype: number
  useridparam: string
  useridvalue: string
  passparam: string
  passvalue: string
  msisdnvalue: string
  sendervalue: string
  smstextvalue: string
  createdate: string
  url: string
  prefixnotallow: string
  name: string
  isalternate: number
  issetenforce: number
  dlrurl: string
  dlravailable: string
  routeFaildSmsCount: number
  routeTpsLimitSet: number
  routePerDaySmsSendLimit: number
  retryCounterLimit: number
}

export interface IRouteConfig extends IBaseConfig {
  id: number
}

export interface IRouteConfigForm extends IBaseConfig {
  msisdnparam: string
  senderparam: string
  smstextparam: string
  routeAliveTime: string
  routeSleepTime: string
  routeIntervelTime: number
  routeDefaultSenderId: number
  submittedTimeOut: number
  retryIntervelTime: number
  smscTypeName: string
  sender: string
  balanceCheck: number
  balanceUrl: string
  mnoId: string
}

export interface ISmsRouteConfig {
  id: number
  smsctype: number
  useridparam: string
  useridvalue: string
  passparam: string
  passvalue: string
  msisdnparam: string
  msisdnvalue: string
  senderparam: string
  sendervalue: string
  smstextparam: string
  smstextvalue: string
  createdate: string // Date string format: "YYYY-MM-DD HH:MM:SS"
  url: string
  prefixnotallow: string
  name: string
  isalternate: number
  issetenforce: number
  dlrurl: string
  dlravailable: string
  routeFaildSmsCount: number
  routeAliveTime: string // Date string format: "YYYY-MM-DD HH:MM:SS"
  routeSleepTime: string // Date string format: "YYYY-MM-DD HH:MM:SS"
  routeTpsLimitSet: number
  routePerDaySmsSendLimit: number
  routeIntervelTime: number
  routeDefaultSenderId: number
  submittedTimeOut: number
  retryCounterLimit: number
  retryIntervelTime: number
  balanceCheck: number
  balanceUrl: string
  mnoId: string
}

export const initRouteConfig: IRouteConfigForm = {
  smsctype: 0, //
  useridparam: '',
  useridvalue: '',
  passparam: '',
  passvalue: '',
  msisdnparam: '', //
  msisdnvalue: '<MSISDN>',
  sendervalue: '<SENDER>',
  senderparam: '', //
  smstextparam: '', //
  smstextvalue: '<MESSAGE>',
  // url: 'https://apismsv3.iatlbd.com/api/infozillionTest/send-sms',
  url: '',
  prefixnotallow: 'N',
  name: '',
  isalternate: 1,
  issetenforce: 0,
  dlrurl: 'https://apismsv3.iatlbd.com/api/infozillionTest/send-sms',
  dlravailable: 'Disable',
  routeFaildSmsCount: 0,
  routeAliveTime: '2025-07-21 06:00:00',
  routeSleepTime: '2025-07-21 06:00:00',
  createdate: '', //
  routeTpsLimitSet: 0,
  routePerDaySmsSendLimit: 0,
  routeIntervelTime: 0,
  routeDefaultSenderId: 1, //
  submittedTimeOut: 0,
  retryCounterLimit: 0,
  retryIntervelTime: 0,
  smscTypeName: '',
  sender: '8809617619344',
  balanceCheck: 0,
  balanceUrl: '0',
  mnoId: '0',
}

export const smscTypeOptions = [
  {
    id: 11,
    value: 'Masking',
    label: 'Masking',
  },
  {
    id: 12,
    value: 'Non Masking',
    label: 'Non Masking',
  },
  {
    id: 13,
    value: 'IPTSP',
    label: 'IPTSP',
  },
]

export const dlrOptions = [
  {
    id: 1,
    value: 'Enable',
    label: 'Enable',
  },
  {
    id: 2,
    value: 'Disable',
    label: 'Disable',
  },
]

export const getSmscType = (id: number) => {
  let smsc_type = ''

  switch (id) {
    case 11:
      smsc_type = 'Masking'
      break
    case 12:
      smsc_type = 'Non Masking'
      break
    case 13:
      smsc_type = 'IPTSP'
      break
    default:
      break
  }

  return smsc_type
}
